import { Reveal } from "../Reveal";
import { PROCESS_STEPS, STORY_IMAGES } from "../../lib/content";

export default function Process() {
  return (
    <section
      id="craft"
      data-testid="process-section"
      className="relative bg-bone py-24 md:py-40 overflow-hidden"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-7">
            <Reveal>
              <div className="flex items-center gap-4 mb-6">
                <span className="overline text-matcha-dark">— Chapter Three</span>
                <span className="h-px w-24 bg-ink/30" />
              </div>
              <h2
                className="font-serif font-light leading-[1] tracking-tight text-ink"
                style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
              >
                From leaf
                <br />
                <span className="italic font-cormorant text-matcha-dark">
                  to bowl, slowly.
                </span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
            <Reveal delay={0.1}>
              <p className="text-ink-soft leading-relaxed">
                Three steps. Three rules. Nothing rushed. The whole journey,
                from the field outside Kyoto to the cup in your hand, takes
                care — and almost no machinery.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/10 border border-ink/10 rounded-sm overflow-hidden">
          {PROCESS_STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} className="bg-bone">
              <div className="p-8 md:p-12 h-full flex flex-col justify-between min-h-[320px] md:min-h-[420px] group">
                <div
                  className="font-serif font-light text-matcha leading-none"
                  style={{ fontSize: "clamp(4rem, 9vw, 8rem)" }}
                >
                  {s.n}
                </div>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-ink mb-4">
                    {s.title}
                  </h3>
                  <p className="text-ink-soft leading-relaxed text-sm md:text-base max-w-sm">
                    {s.body}
                  </p>
                  <div className="mt-6 h-px w-12 bg-matcha group-hover:w-24 transition-all duration-700" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Decorative quote */}
        <div className="grid grid-cols-12 gap-6 md:gap-12 mt-24 md:mt-32 items-center">
          <div className="col-span-12 md:col-span-5">
            <Reveal>
              <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
                <img
                  src={STORY_IMAGES.whisk}
                  alt="Hand whisk"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <Reveal delay={0.1}>
              <p
                className="font-cormorant italic text-ink/85 leading-tight"
                style={{ fontSize: "clamp(1.75rem, 3.4vw, 3rem)" }}
              >
                "There is nothing the chasen and the bowl can't say —
                <br />
                if you let them speak."
              </p>
              <p className="overline text-ink-soft mt-8">— Matcha Story</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
